module.exports = __webpack_public_path__ + "img/facebook.fc7cbb45.png";